/**
 * The public website, for links to its legal pages. Set VITE_WEBSITE_URL at
 * build time for another host; the live site otherwise.
 */
export const WEBSITE_URL: string = (import.meta.env.VITE_WEBSITE_URL as string | undefined)?.replace(/\/$/, '') || 'https://repletoryreach.co.za';

export function websitePage(path: string): string {
  return `${WEBSITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
}
